export default __webpack_public_path__ + "static/media/cloud-upload.ad0c3747.svg";